import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=1c4faec0"
import script from "./TheLayout.vue?vue&type=script&lang=js"
export * from "./TheLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports